import { Button, Modal } from "react-bootstrap";
import telegramImage from '../../public/image/telegram.png'
import whatsappImage from '../../public/image/whatsapp.png'
import baleImage from '../../public/image/Bale.png'
import eitaaImage from '../../public/image/Eitaa.png'
import rubikaImage from '../../public/image/rubika.png'
import Image from "./Image";
import './ConfirmOrderModal.css'
import { useEffect, useState } from "react";
import { charsNormalize } from "../../util/charactorsNormalize";

const ConfirmOrderModal = ({ show, handleClose, message, onConfirm, defaultMobile }) => {

    const [messenger, setMessenger] = useState('');
    const regix = new RegExp(/^(0)?9\d{9}$/);
    const [phoneNumber, setPhoneNumber] = useState(defaultMobile);
    const [isValid, setIsValid] = useState(true);

    const getStatusOfInput = () => {
        if (isValid) {
            return 'mb-1 form-control phone-number is-valid'
        }
        else {
            return 'mb-1 form-control phone-number is-invalid'
        }

    }

    const getMessengerLabel = () => {
        let label = '';
        switch (messenger) {
            case 'telegram':
                label = '« تلگرام »'
                break;
            case 'whatsapp':
                label = '« واتساپ »'
                break;
            case 'bale':
                label = '« بله »'
                break;
            case 'eitaa':
                label = '« ایتا »'
                break;
            case 'rubika':
                label = '« روبیکا »'
                break;
            default:
                break;
        }
        return label;
    }
    useEffect(() => {
        if (!show) {
            setMessenger('')
            setPhoneNumber('')
            setIsValid(false);
        }
        else {
            setPhoneNumber(defaultMobile)
            setIsValid(true);
        }
    }, [show, defaultMobile])
    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="md"
            centered
            style={{ direction: 'rtl', textAlign: 'right' }}
            className="modalOnModal"
            backdropClassName=" backOnModal"
        >
            <Modal.Header className="bg-warning">
                <Modal.Title id="contained-modal-title-vcenter" >
                    <i className="fa fa-warning me-2"></i>
                    توجه
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="pb-2 pt-3 text-center alert">
                    پیش فاکتور شما بعد از تأیید در کدام پیام رسان برای شما ارسال شود ؟
                </p>
                <div className="row">
                    <div className="col-6">
                        <div className="form-check media-selection">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                checked={messenger === 'eitaa'}
                                onChange={() => setMessenger('eitaa')}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                                <Image
                                    src={eitaaImage}
                                    width={33}
                                    height={33}
                                />
                                <span>ایتا</span>
                            </label>
                        </div>
                        <div className="form-check media-selection">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault2"
                                checked={messenger === 'rubika'}
                                onChange={() => setMessenger('rubika')}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefault2">
                                <Image
                                    src={rubikaImage}
                                    width={33}
                                    height={33}
                                />
                                <span>روبیکا</span>
                            </label>
                        </div>
                        <div className="form-check media-selection">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault3"
                                checked={messenger === 'bale'}
                                onChange={() => setMessenger('bale')}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefault3">
                                <Image
                                    src={baleImage}
                                    width={33}
                                    height={33}
                                />
                                <span>بله</span>
                            </label>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-check media-selection">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault4"
                                checked={messenger === 'whatsapp'}
                                onChange={() => setMessenger('whatsapp')}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefault4">
                                <Image
                                    src={whatsappImage}
                                    width={35}
                                    height={35}
                                />
                                <span>واتساپ</span>
                            </label>
                        </div>
                        <div className="form-check media-selection">
                            <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault5"
                                checked={messenger === 'telegram'}
                                onChange={() => setMessenger('telegram')}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefault5">
                                <Image
                                    src={telegramImage}
                                    width={30}
                                    height={30}
                                />
                                <span>تلگرام</span>
                            </label>
                        </div>
                    </div>
                </div>
                {
                    messenger &&
                    <>
                        <p className="pb-2 pt-3 text-center alert">
                            پیش فاکتور به چه شماره ای در {getMessengerLabel(messenger)} ارسال شود ؟
                        </p>
                        <input
                            type="tel"
                            className={getStatusOfInput()}
                            style={{ width: '200px', margin: '0 auto 0 auto' }}
                            id="phoneNumber"
                            placeholder=""
                            value={phoneNumber}
                            onChange={(e) => {
                                if (regix.test(e.target.value)) {
                                    setIsValid(true);
                                }
                                else {
                                    setIsValid(false);
                                }
                                setPhoneNumber(charsNormalize(e.target.value));
                            }}
                            onBlur={() => {
                                if (phoneNumber !== '') {
                                }
                            }}
                        />
                    </>
                }
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button variant="warning" onClick={() => onConfirm({ messengerName: messenger, messengerNumber: phoneNumber })} style={{ width: '120px' }} disabled={!messenger || !isValid}>ثبت نهایی</Button>
                <Button variant="secondary" onClick={handleClose} style={{ width: '120px' }}>لغو عملیات</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmOrderModal;
